import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { SelectionModel } from '@angular/cdk/collections';
import { TranslateService } from '@ngx-translate/core';
import { finalize } from 'rxjs/operators';
import {DocumentService} from 'src/app/core/services/document.service';
import {DocumentTypeService} from '../../../../../../core/services/document-type.service';
import {ReplaySubject, Subscription} from 'rxjs';
import {SelectVersionDialogComponent} from '../../../../../../shared/components/header/select-version-dialog/select-version-dialog.component';
import {MatDialog} from "@angular/material";
import {SelectContractReviewDialogComponent} from '../../../../../../shared/components/header/select-contract-review-dialog/select-contract-review-dialog.component';
import { LaborContractStandardizeExecuteComponent } from '../labor-contract-standardize-execute/labor-contract-standardize-execute.component';
import { NoteDialogComponent, NoteDialogData } from './note-dialog/note-dialog.component';
import { ActivatedRoute } from '@angular/router';
import { MatTabChangeEvent } from '@angular/material/tabs';

// import {
//   ContractStandardizeService,
//   FilterStandardizedContractApiItem,
//   FilterStandardizedContractRequest
// } from './contract-standardize.service';

export interface FilterStandardizedContractApiItem {
  id: string;
  name: string;
  allName: string;
  serviceTypeName: string;
  statusReview: string;
  statusDigitalCert: string;
  statusDigitalCertPersonal: string;          // lưu ý: field thật là "statusDigitalCertPersonal"
  statusStandardized: string;
  statusUpdateInfoProperties: string;
  descriptionStandardized: string;
}
// ==== Interface cho từng dòng hiển thị trên table ====
export interface ContractStandardizeItem {
  id: string;
  idNotify: string;
  stt: number;
  codeName: string;
  contractType: string;
  signers: string;
  reviewStatus: string;
  cksNsdldStatus: string;
  cksNldStatus: string;
  standardizeStatus: string;
  additionalInfoStatus: string;
  note: string;
}

export interface FilterStandardizedContractRequest {
  nameOrCode: string,
  serviceType: any,
  statusReview: string,
  statusStandardized: string,
  page: any,
  pageSize: any
}


@Component({
  selector: 'app-standardizing-labor-contracts',
  templateUrl: './standardizing-labor-contracts.component.html',
  styleUrls: ['./standardizing-labor-contracts.component.scss']
})
export class StandardLaborContractComponent implements OnInit {

  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild('contractTypeSearchInput', { static: false }) contractTypeSearchInput!: ElementRef<HTMLInputElement>;

  // ==== Tab control ====
  selectedTabIndex = 0;

  // ==== Search form model (template-driven) ====
  documents: any = {
    contractCode: '',       // -> nameOrCode
    contractType: null,     // -> serviceType (id loại hợp đồng)
    reviewStatus: null,     // -> statusReview
    standardizeStatus: null // -> statusStandardized
  };

  serviceTypes = [];

  public filteredContractTypeOptions: ReplaySubject<comboBox[]> = new ReplaySubject<comboBox[]>(1);
  contractTypeOptions: comboBox[] = []; 
  contractTypeSearchText = '';

  reviewStatusOptions = [
    { value: 'WAIT', label: this.translate('labor_contract_standardize.review_status.WAIT') },
    { value: 'DONE', label: this.translate('labor_contract_standardize.review_status.DONE') },
    { value: 'ERROR', label: this.translate('labor_contract_standardize.review_status.ERROR') }
  ];

  standardizeStatusOptions = [
    { value: 'NOT_STANDARDIZED', label: this.translate('labor_contract_standardize.standardize_status.NOT_STANDARDIZED') },
    { value: 'LACKING_CONDITIONS', label: this.translate('labor_contract_standardize.standardize_status.LACKING_CONDITIONS') },
    { value: 'WAIT', label: this.translate('labor_contract_standardize.standardize_status.WAIT') },
    { value: 'DONE', label: this.translate('labor_contract_standardize.standardize_status.DONE') }
  ];

  // ==== Table ====
  displayedColumns: string[] = [
    'stt', 'codeName', 'contractType', 'signers',
    'reviewStatus', 'cksNsdldStatus', 'cksNldStatus',
    'additionalInfoStatus', 'standardizeStatus', 'note'
  ];

  dataSource = new MatTableDataSource<ContractStandardizeItem>([]);
  selection = new SelectionModel<string>(true, []);
  isLoading = false;

  // ==== Pagination (object chuẩn cho app-pagination, currentPage tính từ 0) ====
  totalRecords = 0;
  totalPages = 1;
  paginate: Paginate = {
    currentPage: 0,
    pageSize: 10,
    totalRow: 0,
    totalPage: 0,
    totalPageArray: [],
    no: []
  };

  constructor(
    public dialog: MatDialog,
    private translateService: TranslateService,
    private documentService: DocumentService,
    private documentTypeService: DocumentTypeService,
    private route: ActivatedRoute)
    {


    }

    ngOnInit(): void {
      const tab = Number(this.route.snapshot.queryParamMap.get('tab'));
      this.selectedTabIndex = tab === 1 ? 1 : 0;
      this.getServiceTypes();
      this.onSearch();
    }

  private translate(key: string): string {
    return this.translateService.instant(key);
  }

  getServiceTypes() {
    this.documentTypeService.getServiceTypesMoha(localStorage.getItem('enterpriseId')).subscribe(rs => {
      if (rs == null || rs.data == null) {
        return;
      }
      this.serviceTypes = rs.data;
      const filteredData = rs.data;
      this.contractTypeOptions = filteredData;
      this.filteredContractTypeOptions.next(this.contractTypeOptions);
    });
  }

  // ===================== Search =====================
  onSearch(): void {
    this.paginate.currentPage = 0;
    this.fetchData();
  }

  onResetFilter(): void {
    this.documents = {
      contractCode: '',
      contractType: null,
      reviewStatus: null,
      standardizeStatus: null
    };
    this.onSearch();
  }

  fetchData(): void {
    const request: FilterStandardizedContractRequest = {
      nameOrCode: this.documents.contractCode || '',
      serviceType: this.documents.contractType || null,
      statusReview: this.documents.reviewStatus || '',
      statusStandardized: this.documents.standardizeStatus || '',
      page: this.paginate.currentPage,
      pageSize: this.paginate.pageSize
    };

    this.isLoading = true;
    this.selection.clear();
    this.dataSource.data = [];


    // this.documentService.searchDocumentContractCompany(this.getFilterCondition(page, pageSize, this.documents))
    //   .subscribe(rs => {
    //     if (rs.data != null && rs.data.currentPage != null && rs.data.pageSize != null
    //       && rs.data.totalRow != null) {
    //       this.paginate = {
    //         currentPage: rs.data.currentPage,
    //         pageSize: rs.data.pageSize,
    //         totalRow: rs.data.totalRow,
    //         totalPage: Math.ceil(rs.data.totalRow / rs.data.pageSize),
    //         totalPageArray: this.counter(Math.ceil(rs.data.totalRow / rs.data.pageSize), 1),
    //         no: this.counter(rs.data.pageSize, rs.data.currentPage * rs.data.pageSize + 1)
    //       };
    //     }
    //     console.log('searchDoc::', rs.data);
    //     if (rs.data && rs.data.dataRow != null) {
    //       this.initParent(rs);
    //     }            
    //   });

    this.documentService.filterStandardizedContracts(request)
      .pipe(finalize(() => this.isLoading = false))
      .subscribe(
        (res: any) => this.handleFetchDataSuccess(res),
        (err: any) => this.handleFetchDataError(err)
      );
  }

  private handleFetchDataSuccess(res: any): void {
    const payload = res && res.data ? res.data : res;

    const rows: FilterStandardizedContractApiItem[] = payload && payload.dataRow ? payload.dataRow : [];

    const total: number = payload && payload.totalRow != null ? payload.totalRow : rows.length;

    this.totalRecords = total;
    this.totalPages = Math.max(1, Math.ceil(total / this.paginate.pageSize));

    this.paginate = {
      pageSize: this.paginate.pageSize,
      currentPage: this.paginate.currentPage,
      totalRow: total,
      totalPage: Math.ceil(total / this.paginate.pageSize),
      totalPageArray: this.counter(Math.ceil(total / this.paginate.pageSize), 1),
      no: this.counter(this.paginate.pageSize, this.paginate.currentPage * this.paginate.pageSize + 1)
    };

    this.dataSource.data = rows.map((item, index) => this.mapApiItemToRow(item, index));
  }

  private handleFetchDataError(err: any): void {
    // TODO: hiển thị thông báo lỗi cho người dùng theo pattern chung của dự án (toast/snackbar)
    console.error(this.translate('labor_contract_standardize.note_dialog.load_error'), err);
    this.dataSource.data = [];
    this.totalRecords = 0;
    this.totalPages = 1;
  }

  private mapApiItemToRow(item: FilterStandardizedContractApiItem, index: number): ContractStandardizeItem {
    return {
      id: item.id,
      idNotify: `${this.paginate.currentPage}-${index}`,
      stt: this.paginate.currentPage * this.paginate.pageSize + index + 1,
      codeName: item.name,
      contractType: item.serviceTypeName,
      signers: item.allName,
      reviewStatus: item.statusReview,
      cksNsdldStatus: item.statusDigitalCert,
      cksNldStatus: item.statusDigitalCertPersonal,
      standardizeStatus: item.statusStandardized,
      additionalInfoStatus: item.statusUpdateInfoProperties,
      note: item.descriptionStandardized,
    };
  }

  // ===================== Thêm vào danh sách rà soát =====================
onAddToReviewList(): void {
  const dialogRef = this.dialog.open(SelectVersionDialogComponent, {
    width: '420px',
    panelClass: 'select-version-dialog-panel',
    restoreFocus: false,
  });

  dialogRef.afterClosed().subscribe((result?: { selectedVersion: string }) => {
    if (!result) {
      return; 
    }

    const selectContractDialogRef = this.dialog.open(SelectContractReviewDialogComponent, {
      width: '1110px',
      panelClass: 'select-contract-review-dialog-panel',
      data: { selectedVersion: result.selectedVersion },
      restoreFocus: false,
    });

    selectContractDialogRef.afterClosed().subscribe((selectedContracts?: any[]) => {
      if (selectedContracts && selectedContracts.length) {
        this.onSearch(); 
      }
    });
  });
}

onContractTypeSearchChange(): void {
  const keyword = this.removeVietnameseTones(this.contractTypeSearchText);
  const filtered = !keyword
    ? this.contractTypeOptions
    : this.contractTypeOptions.filter(item =>
        this.removeVietnameseTones(item.name).indexOf(keyword) !== -1);
  this.filteredContractTypeOptions.next(filtered);
}

  // ===================== Popup ghi chú =====================
  openNoteDialog(row: ContractStandardizeItem): void {
    this.dialog.open(NoteDialogComponent, {
      width: '560px',
      panelClass: 'note-dialog-panel',
      data: { contractId: row.id } as unknown as NoteDialogData,
    });
  }
  
  onContractTypeSelectOpenChange(opened: boolean): void {
    if (opened) {
      setTimeout(() => {
        if (this.contractTypeSearchInput) {
          this.contractTypeSearchInput.nativeElement.focus();
        } else {
          // dự phòng nếu ViewChild không bắt được
          const input = document.querySelector('.select-search-input') as HTMLInputElement;
          if (input) {
            input.focus();
          }
        }
      });
    } else {
      this.contractTypeSearchText = '';
      this.filteredContractTypeOptions.next(this.contractTypeOptions);
    }
  }

  // ===================== Selection (checkbox) =====================
  masterToggle(): void {
    if (this.isAllSelected()) {
      this.selection.clear();
    } else {
      this.dataSource.data.forEach(row => this.selection.select(row.idNotify));
    }
  }

  isAllSelected(): boolean {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numRows > 0 && numSelected === numRows;
  }

  addListRecord(row: ContractStandardizeItem): void {
    this.selection.toggle(row.idNotify);
  }

  // ===================== Sort =====================
  sortData(sortState: any): void {
    // TODO: tài liệu API chưa hỗ trợ tham số sort -> cần bổ sung nếu BE support,
    // hiện tại chỉ gọi lại fetchData() giữ nguyên thứ tự BE trả về.
    this.fetchData();
  }

  // ===================== Pagination (app-pagination common) =====================
  onChangePage(e: any): void {
    this.paginate.currentPage = e.page;
    this.paginate.pageSize = e.pageSize;
    this.fetchData();
  }

  counter(index: number, from: number): any {
    return new Array(index).fill(0).map((x, i) => i + from);
  }

  onTabChange(event: MatTabChangeEvent): void {
    if (event.index === 0) {
      this.onResetFilter();
    }
  }

  private removeVietnameseTones(str: string): string {
    return (str || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/đ/g, 'd')
      .replace(/Đ/g, 'D')
      .toLowerCase()
      .trim();
  }

  onContractTypeChange(): void {
    this.onSearch();
  }

  // ==== Màu nz-tag cho trạng thái (đồng bộ với màn hình danh sách HĐ số hóa MOHA) ====
getStatusTagColor(status: string): string {
  switch (status) {
    case 'DONE':
    case 'VALID':
      return 'green';
    case 'WAIT':
    case 'PROCESSING':
    case 'LACKING_CONDITIONS':
      return 'blue';
    case 'ERROR':
    case 'INVALID':
    case 'NOT_STANDARDIZED':
      return 'red';
    default:
      return '';
  }
}
}

export class Paginate {
  currentPage: number;
  pageSize: number;
  totalRow: number;
  totalPage: number;
  totalPageArray: [];
  no: [];
}

